module.exports = __webpack_public_path__ + "img/Circulo-Logo-DesarrolloSoftware-Gris.e0f5c156.png";